import { AddressInput } from '@dealstack/frontend/investor/pages/Investment/common/personalDetails/AddressInput';
import { PersonalInformationInput } from '@dealstack/frontend/investor/pages/Investment/common/personalDetails/PersonalInformationInput';
import { Flex } from '@mantine/core';
import { memo } from 'react';
import { FormProvider } from 'react-hook-form';

import {
	JOIN_ALLOCATION_PERSONAL_INFO_FORM,
	useJoinAndAllocationPersonalInformationController,
} from './useJoinAndAllocationPersonalInformationController';

const JoinAndAllocationPersonalInformation = () => {
	const { personalInformationForm } = useJoinAndAllocationPersonalInformationController();

	return (
		<Flex gap="5rem">
			<FormProvider {...personalInformationForm}>
				<PersonalInformationInput
					firstNameFieldName={JOIN_ALLOCATION_PERSONAL_INFO_FORM.FIRST_NAME}
					lastNameFieldName={JOIN_ALLOCATION_PERSONAL_INFO_FORM.LAST_NAME}
					birthDayFieldName={JOIN_ALLOCATION_PERSONAL_INFO_FORM.BIRTH_DATE}
					phoneNumberFieldName={JOIN_ALLOCATION_PERSONAL_INFO_FORM.PHONE_NUMBER}
					telephonePrefixFieldName={JOIN_ALLOCATION_PERSONAL_INFO_FORM.TELEPHONE_PREFIX}
				/>

				<AddressInput
					postCodeFieldName={JOIN_ALLOCATION_PERSONAL_INFO_FORM.POST_CODE}
					cityFieldName={JOIN_ALLOCATION_PERSONAL_INFO_FORM.CITY}
					countryFieldName={JOIN_ALLOCATION_PERSONAL_INFO_FORM.COUNTRY}
					streetFieldName={JOIN_ALLOCATION_PERSONAL_INFO_FORM.STREET}
					houseNumberFieldName={JOIN_ALLOCATION_PERSONAL_INFO_FORM.HOUSE_NUMBER}
				/>
			</FormProvider>
		</Flex>
	);
};
const _JoinAndAllocationPersonalInformationExport = memo(JoinAndAllocationPersonalInformation);

export { _JoinAndAllocationPersonalInformationExport as JoinAndAllocationPersonalInformation };
